import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  List,
  ListItem,
  Dialog,
  AppBar,
  Toolbar,
  Drawer,
} from "@mui/material";
import { useJsonContext } from "../pages/aptitudeTest";

const TestPart2 = forwardRef((props, ref) => {
  const { nextPage } = props;
  const { testData2 = {} } = props;
  const [testData, setTestData] = useState([]);
  const [timeLeft, setTimeLeft] = useState(900);
  const [isTimeoutDialogOpen, setTimeoutDialogOpen] = useState(false);
  const { jsonData, addValueToJson } = useJsonContext();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isTestDisabled, setTestDisabled] = useState(false);
  const [selectedValues, setSelectedValues] = useState({});
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    handleOpenDialog,
  }));

  // スクロールを実行するための関数を追加
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // カウントダウンタイマーの実装
  useEffect(() => {
    setTestData(Array.isArray(testData2) ? testData2 : []);
    const countdownInterval = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          clearInterval(countdownInterval); // カウントが0になったらタイマーを停止
          setTimeoutDialogOpen(true);
          handleTimeout();
          return 0;
        }
      });
    }, 1000);

    // コンポーネントがアンマウントされたときにタイマーをクリア
    return () => clearInterval(countdownInterval);
  }, []);

  // タイムアウト処理
  const handleTimeout = () => {
    setTimeoutDialogOpen(true);
    setTestDisabled(true); // 問題を解答できなくする
  };

  const handleChange = (event, id) => {
    setSelectedValues({
      ...selectedValues,
      [id]: event.target.value, // 問題IDをキーにして選択された値を更新
    });
  };

  // ボタンのonClickで nextPage の後に submitAnswers を実行
  const handleClick = () => {
    nextPage(); // 親の nextPage 関数を呼び出す
    submitAnswers(); // submitAnswers を実行
  };

  // 選択された回答からJSONを生成する関数
  const submitAnswers = () => {
    const answers = testData.map((problem) => ({
      question_id: problem.questionId,
      question_part: problem.questionPart,
      choice: selectedValues[problem.questionId] || null,
    }));

    const elapsedTime = [
      String(Math.floor((900 - timeLeft) / 60)).padStart(2, "0") +
        ":" +
        String((900 - timeLeft) % 60).padStart(2, "0"),
    ];
    console.log("回答時間" + elapsedTime);

    const answerJsonData = {
      answers: answers,
    };

    // JSONデータを作成
    const answerJsonString = JSON.stringify(answerJsonData);
    addValueToJson("answers", JSON.parse(answerJsonString).answers);
    addValueToJson("answer_times", elapsedTime);
    console.log(jsonData);
    console.log("解答データ (JSON):", JSON.stringify(jsonData));

    // handleOpenDialog();
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
    setTestDisabled(true); // ダイアログが開いている間、問題を無効化
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setTestDisabled(false); // ダイアログが閉じたら、問題を再度有効化
  };

  return (
    <Container component="main" id="js-q-start" sx={{padding: { xs: 0}, pb: { xs: 10, md: 0 }}}>
      {/* *** 2部問題 *** */}
      <Box sx={{ marginY: 2 }}>
        <Typography
          variant="h5"
          sx={{
            margin: "1rem 0",
            paddingLeft: "10px",
            borderLeft: "solid 3px blue",
            fontWeight: "bold",
            lineHeight: "3rem",
            height: "2.8rem",
            backgroundColor: "divider",
            fontSize: { xs: '1.2rem', sm: '1.5rem' },
          }}
        >
          第2部 問題
          <Typography
            component="span"
            sx={{ fontSize: { xs: '0.9rem', sm: '1.2rem' }, marginLeft: 1, color: "9b9b9b" }}
          >
            [ 全30問 制限時間15分 ]
          </Typography>
        </Typography>

        <Box sx={{ paddingLeft: { xs: '10px', sm: '30px' } }}>
          <Typography sx={{ padding: "1rem 0", fontWeight: "bold", fontSize: { xs: '0.9rem', sm: '1rem' } }}>
            各列の左側にある4つの図は、ある一定の規則で並んでいます。
            <br />
            次に来るべき図を右側の5つの図の中から選んでください。
          </Typography>
        </Box>
      </Box>

      {/* Questions */}
      {testData.map((example, index) => (
        <Box
          id={`js-q${example.questionId}`}
          key={index}
          sx={{
            margin: { xs: '2rem 0', sm: '' },
            padding: { xs: '0 10px', sm: '2rem 4rem 2rem 2rem' },
            pointerEvents: isTestDisabled ? "none" : "auto",
            borderBottom: "solid 1px gray",
          }}
        >
          <Typography>
            <Box component="span"
              sx={{
                fontSize: { xs: '0.9rem', sm: '1.4rem' },
                padding: "0.3rem 1.5rem",
                borderRadius: "9%",
                color: "white",
                backgroundColor: "#009ce5",
              }}
            >
              第{example.questionId}問
            </Box>
          </Typography>
          <Box
            sx={{
              padding: { xs: '1.5rem 0 1.5rem', sm: '0.5rem 2rem 2rem', md: '2rem 2rem 1rem 1rem' },
              display: 'grid',
              gridTemplateColumns: {
                xs: '0.2fr 1.6fr',
                md: 'repeat(3, 1fr)',
              },
              gridTemplateRows: {
                xs: 'auto auto auto',
                md: 'auto auto',
              },
              columnGap: 2,
              rowGap: 1,
              alignItems: { xs: 'start', md: 'center' },
            }}
          >

            {/* 問題画像 */}
            <Box
              component="img"
              src={'https://dev-aptitude-test-api-image-bucket.s3.ap-northeast-1.amazonaws.com' + example.questionImageName}
              sx={{
                width: '100%',
                maxWidth: { xs: '70%', sm: '60%', md: '100%' },
                objectFit: 'contain',
                justifySelf: { xs: 'start', md: 'center' },
                maxHeight: { xs: '4rem', sm: '4.6rem', md: '5rem' },

                // 配置切替
                gridColumn: { xs: '2 / 3', md: '1 / 2' },
                gridRow: { xs: '1 / 2', md: '1 / 2' },
              }}
            />

            {/* 解答文字 */}
            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: "bold",
                textAlign: { xs: 'left', md: 'right' },
                alignSelf: 'center',

                gridColumn: { xs: '1 / 2', md: '2 / 3' },
                gridRow: { xs: '2 / 3', md: '1 / 2' },
              }}
            >
              解答
            </Typography>

            {/* 解答画像 */}
            <Box
              component="img"
              src={'https://dev-aptitude-test-api-image-bucket.s3.ap-northeast-1.amazonaws.com' + example.correctImageName}
              alt={`${example.questionId}解答`}
              sx={{
                width: '100%',
                maxWidth:  { xs: '70%', sm: '60%', md: '100%' },
                objectFit: 'contain',
                justifySelf: { xs: 'start', md: 'center' },

                gridColumn: { xs: '2 / 3', md: '3 / 4' },
                gridRow: { xs: '2 / 3', md: '1 / 2' },
              }}
            />

            {/* ラジオボタン */}
            <FormControl
              component="fieldset"
              sx={{
                width: '100%',
                maxWidth:  { xs: '70%', sm: '60%', md: '100%' },
                gridColumn: { xs: '2 / 3', md: '3 / 4' },
                gridRow: { xs: '3 / 4', md: '2 / 3' },
              }}
            >
              <RadioGroup
                row
                value={selectedValues[example.questionId] || ""}
                onChange={(e) => handleChange(e, example.questionId)}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(5, 1fr)",
                  justifyItems: "center",
                }}
              >
              {example.answerChoices.map((choice, i) => (
                <FormControlLabel
                  key={i}
                  value={choice}
                  control={<Radio />}
                  sx={{ margin: 0 }}
                />
              ))}
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>
      ))}

      <Box id="js-q-end" sx={{ margin: { xs: '3rem 0', sm: '6rem 0 5rem 0' } }}>
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: "1.5rem",
            fontSize: { xs: '1.2rem', sm: '1.5rem' },
          }}
        >
          第2部の問題は以上です。
        </Typography>
        <Typography
          sx={{ fontSize: { xs: '0.9rem', sm: '1.1rem' }, textAlign: "center", marginBottom: "4rem" }}
        >
          [ 解答を終える ]ボタンを押して第3部へ進んでください。
          <br />
          但し一度進むと、戻って解答することは出来ないので注意してください。
        </Typography>
      </Box>

      <Box
        sx={{
          position: "fixed",
          top: "50%",
          right: 5,
          transform: "translateY(-60%)",
          display: { xs: 'none', sm: 'block' },
        }}
      >
        <Typography variant="body1">
          残り時間 <span>{Math.floor(timeLeft / 60)}</span>分
          <span>{timeLeft % 60}</span>秒
        </Typography>
        <List
          sx={{
            fontSize: "1.2rem",
            justifyContent: "space-between",
            padding: 0,
          }}
        >
          {[
            { id: "js-q-start", label: "先頭へ移動" },
            { id: "js-q50", label: "第50問" },
            { id: "js-q60", label: "第60問" },
            { id: "js-q-end", label: "最後へ移動" },
          ].map((item, index) => (
            <ListItem
              key={index}
              sx={{
                backgroundColor:
                  item.label === "先頭へ移動" ? "#24509B" : "#F3F3F3", // 条件付きで背景色を設定
                padding: "8px 16px",
                borderRadius: "1px",
                marginBottom: "1.5px",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor:
                    item.label === "先頭へ移動" ? "#1a3e7f" : "#24509B",
                  "& a": {
                    color: "#ffffff",
                  },
                },
              }}
            >
              <Box
                component="a"
                onClick={() => scrollToSection(item.id)}
                sx={{
                  textDecoration: "none",
                  color: item.label === "先頭へ移動" ? "#ffffff" : "#24509B", // "先頭へ移動" の場合は白色
                  display: "block",
                  width: "100%",
                }}
              >
                {item.label}
              </Box>
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Mobile Sticky Footer */}
      <AppBar position="fixed" sx={{ top: 'auto', bottom: 0, display: { xs: 'block', sm: 'none' } }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography variant="body1" sx={{ color: 'white', fontSize: '0.9rem' }}>
            残り時間 {Math.floor(timeLeft / 60)}分 {timeLeft % 60}秒
          </Typography>
          <Button color="inherit" onClick={() => setDrawerOpen(true)}>
            問題番号へ
          </Button>
        </Toolbar>
      </AppBar>

      {/* Mobile Shortcut Drawer */}
      <Drawer
        anchor="bottom"
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <List
          sx={{
            fontSize: "1.2rem",
            padding: 2,
          }}
        >
          {[
            { id: "js-q-start", label: "先頭へ移動" },
            { id: "js-q50", label: "第50問" },
            { id: "js-q60", label: "第60問" },
            { id: "js-q-end", label: "最後へ移動" },
          ].map((item, index) => (
            <ListItem
              key={index}
              sx={{
                backgroundColor: "#F3F3F3",
                padding: "12px 16px",
                borderRadius: "4px",
                marginBottom: "8px",
                cursor: "pointer",
                textAlign: 'center',
                "&:hover": {
                  backgroundColor: "#24509B",
                  "& a": {
                    color: "#ffffff",
                  },
                },
              }}
            >
              <Box
                component="a"
                onClick={() => {
                  scrollToSection(item.id);
                  setDrawerOpen(false);
                }}
                sx={{
                  textDecoration: "none",
                  color: "#24509B",
                  display: "block",
                  width: "100%",
                }}
              >
                {item.label}
              </Box>
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* Confirmation Dialog */}
      <Dialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
      >
        <Box sx={{ padding: { xs: 4, sm: 12 }, textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{ marginBottom: "3rem", fontWeight: "bold", fontSize: { xs: '1.5rem', sm: '2.5rem' } }}
          >
            本当によろしいですか？
          </Typography>
          <Typography
            sx={{ fontSize: { xs: '1rem', sm: '1.2rem' }, fontWeight: "bold", marginY: 2 }}
          >
            このまま進んでよろしければボタンを押して試験を終了し、
            <br />
            次の問題に進んでください。
          </Typography>
          <Box sx={{ marginTop: 4, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', gap: 2 }}>
            <Button
              variant="outlined"
              id="back"
              sx={{
                marginRight: { sm: 2 },
                padding: "1rem",
                fontSize: { xs: '1rem', sm: '1.5rem' },
                fontWeight: "bold",
              }}
              onClick={handleCloseDialog}
            >
              解答に戻る
            </Button>
            <Button
              variant="contained"
              color="primary"
              id="next"
              onClick={() => {
                handleClick();
              }}
              sx={{ padding: "1rem", fontSize: { xs: '1rem', sm: '1.5rem' }, fontWeight: "bold" }}
            >
              解答を終え3部例題に進む
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Timeout Dialog */}
      <Dialog
        open={isTimeoutDialogOpen}
        id="lb_timeout"
        fullWidth
        maxWidth="md"
      >
        <Box sx={{ padding: { xs: 4, sm: 10 }, textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{ marginBottom: "3rem", fontWeight: "bold", fontSize: { xs: '1.5rem', sm: '2.5rem' } }}
          >
            試験終了
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginY: 2,
              padding: "1rem",
              fontSize: { xs: '1rem', sm: '1.5rem' },
              fontWeight: "bold",
            }}
          >
            制限時間が過ぎました。ボタンを押して試験を終了し、
            <br />
            次の問題に進んでください。
          </Typography>
          <Button
            variant="contained"
            color="primary"
            id="next_timeout"
            onClick={() => {
              handleClick();
            }}
            sx={{ padding: "1rem", fontSize: { xs: '1rem', sm: '1.5rem' }, fontWeight: "bold" }}
          >
            解答を終え3部例題に進む
          </Button>
        </Box>
      </Dialog>
    </Container>
  );
});

export default TestPart2;
